/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum MopsPainScaleAliases {
  AGITATION_FIELD = 'agitation-field',
  AGITATION_FORM = 'agitation-form',
  AGITATION_RADIO_GROUP = 'agitation-radio-group',
  AGITATION_TEXT = 'agitation-text',
  CRYING_FIELD = 'crying-field',
  CRYING_FORM = 'crying-form',
  CRYING_RADIO_GROUP = 'crying-radio-group',
  CRYING_TEXT = 'crying-text',
  MODAL_PAIN_SCALE_REFERENCE = 'modal-pain-scale-reference',
  MOPS_PAIN_SCALE_CONTEXTUAL_BAR = 'mops-pain-scale-contextualBar',
  MOPS_PAIN_SCALE_LAYOUT = 'mops-pain-scale-layout',
  MOPS_PAIN_SCALE_PANEL = 'mops-pain-scale-panel',
  POSTURE_FIELD = 'posture-field',
  POSTURE_FORM = 'posture-form',
  POSTURE_RADIO_GROUP = 'posture-radio-group',
  POSTURE_TEXT = 'posture-text',
  REFERENCE_LINK = 'reference-link',
  REFERENCE_MODAL = 'reference-modal',
  REFERENCE_PANEL = 'reference-panel',
  TEXT_PAIN_SCALE_FIELD_REFERENCE = 'text-pain-scale-field-reference',
  TRANSACTION_FIELD = 'transaction-field',
  TRANSACTION_FORM = 'transaction-form',
  TRANSACTION_RADIO_GROUP = 'transaction-radio-group',
  TRANSACTION_TEXT = 'transaction-text',
  VERBAL_FIELD = 'verbal-field',
  VERBAL_FORM = 'verbal-form',
  VERBAL_RADIO_GROUP = 'verbal-radio-group',
  VERBAL_TEXT = 'verbal-text',
}
export { MopsPainScaleAliases };
